module.exports = __webpack_public_path__ + "img/apolar-procura.7f9916bd.svg";